import 'Plugins/mapboxPlugin';
import initFiltering from '../components/filtering';
import initSearch from '../components/search';

const Handlebars = require('handlebars');

export default function initMapbox() {
	jQuery('.search-wrapper').each(function() {
		const holder = jQuery(this);
		const mapHolder = holder.find('.mapbox-holder');
		const filterList = holder.find('.card-wrapp');

		mapHolder.mapbox({
			onDataLoad: (data) => {
				const source = jQuery(filterList.data('template')).html();
				const template = Handlebars.compile(source);

				filterList.append(template(data));

				initFiltering(data);
			}
		});
	});


	jQuery('.filtration-finder').each(function() {
		const holder = jQuery(this);
		const mapHolder = holder.find('.mapbox-holder');
		const filterList = holder.find('.address-col');

		mapHolder.mapbox({
			onDataLoad: (data) => {
				const source = jQuery(filterList.data('template')).html();
				const template = Handlebars.compile(source);

				filterList.append(template(data));

				initSearch(data);
			}
		});
	});
}